<template>
    <div v-if="!hideDetails" class="feed-activity-list">
      <div class="feed-element" v-for="log in logs" :key="log.id">
        <div class="media-body">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <span style="font-size: medium;">{{ log.message }}</span><br>
            <strong>{{ log.time | aTime('DD.MM.Y HH:mm') }}</strong>
          </div>
          <div v-if="log.data && Object.keys(log.data).length" class="col-lg-6 col-md-12">
            <div><strong>Old Value: </strong><span>{{ log.data['oldVal'] }}</span></div>
            <div><strong>New Value: </strong><span>{{ log.data['newVal'] }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="feed-activity-list">
      <div class="feed-element" v-for="log in logs" :key="log.id">
        <div class="media-body">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <span style="font-size: medium;">{{ log.message }}</span><br>
            <strong>{{ log.time | aTime('DD.MM.Y HH:mm') }}</strong>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

export default {
  props: ['logs', 'hideDetails']
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Tabs/ChangesLogs.vue